import { API_URL } from "../config";
import { CBEWSL_SITE_CODE } from "../host";
import axios from "axios";

export const getEarthquakeInformation = (callback) => {
  axios
    .get(
      `${API_URL}/api/analysis/get_earthquake_information/${CBEWSL_SITE_CODE}`
    )
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
